import { Fragment } from 'react'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import ListItemAvatar from '@mui/material/ListItemAvatar'
import Avatar from '@mui/material/Avatar'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import { useTranslations } from 'next-intl'

const style = {
  p: 0,
  width: '100%',
  // maxWidth: 360,
  borderRadius: 2,
  border: '1px solid',
  borderColor: 'divider',
  backgroundColor: 'background.paper'
}

function ListDividers () {
  const t = useTranslations('Volunteering')

  return (
    <List sx={style}>
      <ListItem>
        <ListItemAvatar>
          <Avatar>
            <CheckBoxIcon />
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={t('fluent-title')}
          secondary={
            <Fragment>
              <Typography
                component="span"
                variant="body2"
                sx={{ color: 'text.primary', display: 'inline' }}
              >
                {t('capable-of-managing')}
              </Typography>
            </Fragment>
          }
        />
      </ListItem>
      <Divider component="li" />
      <ListItem>
        <ListItemAvatar>
          <Avatar>
            <CheckBoxIcon />
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={t('immersed-title')}
          secondary={
            <Fragment>
              <Typography
                component="span"
                variant="body2"
                sx={{ color: 'text.primary', display: 'inline' }}
              >
                {t('nearly-fluent')}
              </Typography>
            </Fragment>
          }
        />
      </ListItem>
      <Divider component="li" />
      <ListItem>
        <ListItemAvatar>
          <Avatar>
            <CheckBoxIcon />
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={t('professional-title')}
          secondary={
            <Fragment>
              <Typography
                component="span"
                variant="body2"
                sx={{ color: 'text.primary', display: 'inline' }}
              >
                {t('ready-for-professional')}
              </Typography>
            </Fragment>
          }
        />
      </ListItem>
    </List>
  )
}

export default ListDividers
